/**
 * Marks an individual notification as read with a fetch request.
 *
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { id: String };

  markAsRead() {
    fetch(`/notifications/${this.idValue}/mark_as_read`, {
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content,
      },
      method: "PUT",
      keepalive: true,
    }).catch((error) => {
      console.log("error", error);
    });
  }
}
